import React, { useEffect, useState } from 'react';
import { ModalFactory } from '../../components/modal/modal';
import { Link } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { connect } from 'react-redux';
import {
  AdvertisingContainer,
  AdvertisingWrapper,
  BannerPopUPWrapper,
  Dot,
  ModalContainer
} from './advertising.style';
import { AccountType, AdvertiseContent, Button, Popup } from './advertising.types';
import { ADVERTISE_DATA } from '../../utils/constants/advertiseContent';
import { BASE_CDN_IMAGE_URL } from '../../utils/constants';
import {
  getContentSchemaFromContentFul,
  makeApiCall
} from '../../redux/actions/common/common-action';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import { IStore } from '../../store.type';
import { getFlagValue, isFlagEnabled } from '../../redux/actions/flagsmith/flagsmith-main';
import { RenderElementsWithDelay } from '../../components/render-elements-with-delay/RenderElementsWithDelay';
import CommonButton from '../../components/common-button/CommonButton';
import { CROSS_ICON, MOBILE_CIRCLE_ICON } from '@Images';
import { getAbsolutePath } from '@Utils/library';

interface IAdvertising {
  noMarginRight?: boolean;
  dispatch?: any;
  country_code: string;
  account_type: AccountType;
  status: string;
  additional_info?: {
    user_consents?: {
      is_user_interested_for_forex?: boolean | null;
    };
  };
  remitterInfoDataLoaded?: boolean;
  advertisements?: {
    key: string;
    id: string;
    consent_id?: string;
    cmsData?: {
      [key: string]: {
        content_type: string;
        title: string;
      };
    };
  }[];
  className?: string;
  getStateData?: (update_state: any) => void;
  businessPromotedPaymentMethodData?: any;
}

const Advertising: React.FC<IAdvertising> = (props) => {
  const [advertiseContent, setAdvertiseContent] = useState<AdvertiseContent[]>([]);
  const {
    noMarginRight,
    advertisements,
    className,
    getStateData,
    account_type,
    country_code,
    status,
    remitterInfoDataLoaded,
    dispatch,
    additional_info,
    businessPromotedPaymentMethodData
  } = props;
  useEffect(() => {
    remitterInfoDataLoaded && businessPromotedPaymentMethodData && getDataFromFlagsmith();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remitterInfoDataLoaded, businessPromotedPaymentMethodData]);
  const getDataFromFlagsmith = () => {
    if (!isEmpty(businessPromotedPaymentMethodData)) {
      setAdvertiseContent(businessPromotedPaymentMethodData);
      return;
    }
    if (isEmpty(advertisements)) return;
    const flagsmithData: AdvertiseContent[] = [];
    advertisements?.forEach(({ key, id, consent_id, cmsData }) => {
      (async (flagsmithKey, contentID) => {
        if (isFlagEnabled(flagsmithKey)) {
          const parcedData = getFlagValue(flagsmithKey);

          if (parcedData?.countries?.includes(country_code)) {
            let data: AdvertiseContent | null = null;
            if (!isEmpty(cmsData) && cmsData) {
              const cmsResponse = await getContentSchemaFromContentFul(
                cmsData[country_code].content_type,
                cmsData[country_code].title
              );
              if (!isEmpty(cmsResponse?.content)) {
                data = cmsResponse?.content?.value?.[contentID.toUpperCase()];
                if (!isEmpty(cmsResponse?.buttonImage)) {
                  const btnImageUrl = 'https:' + cmsResponse?.buttonImage?.target?.fields?.url;
                  if (data?.button.btn_content) data.button.btn_content.image = btnImageUrl;
                }
              }
            } else {
              data = ADVERTISE_DATA.advertisingCountries[country_code][contentID.toUpperCase()];
            }
            const showAdvertisement = consent_id
              ? get(additional_info, `user_consents.${consent_id}`, null) === null
              : true;
            /* 
              1st check - no data provided no check needed. show content for this user
              2st check - both data provided acc type and user status need to match
              3rd/4th check - any one data provide if provided data matches show content
            */
            if (data) {
              data.id = contentID;
              if (
                //1st check
                ((isEmpty(data.accountType) && isEmpty(data.userStatus)) ||
                  //2nd check
                  (!isEmpty(data.accountType) &&
                    data.accountType === account_type &&
                    !isEmpty(data.userStatus) &&
                    data.userStatus === status) ||
                  //3rd check
                  (!isEmpty(data.accountType) &&
                    data.accountType === account_type &&
                    isEmpty(data.userStatus)) ||
                  //4th check
                  (isEmpty(data.accountType) &&
                    !isEmpty(data.userStatus) &&
                    data.userStatus === status)) &&
                showAdvertisement
              ) {
                flagsmithData.push(data);
              }
            }
            setAdvertiseContent([...flagsmithData]);
          }
        }
      })(key, id);
    });
  };

  const getElementByAction = (config: Button, onClose?: any, id?: string) => {
    const {
      action,
      btn_content,
      popup_content,
      className,
      redirect_content,
      deleteContent,
      update_state
    } = config || {};
    const actionType = !isEmpty(businessPromotedPaymentMethodData)
      ? businessPromotedPaymentMethodData?.button?.action
      : action;

    const getBtnImage = () => {
      if (btn_content.image) {
        if (btn_content.image.startsWith('https'))
          return <img width={'24px'} src={btn_content.image} alt="logo" />;
        return <img width={'24px'} src={`${BASE_CDN_IMAGE_URL}/${btn_content.image}`} alt="logo" />;
      }
    };
    switch (actionType) {
      case 'POPUP':
        return (
          <button
            className={
              className || businessPromotedPaymentMethodData?.button?.btn_content?.className
            }
            onClick={() =>
              handlePopup(
                popup_content,
                id,
                false,
                businessPromotedPaymentMethodData?.button?.update_state
              )
            }
          >
            {!isEmpty(businessPromotedPaymentMethodData) ? (
              <img
                width={'24px'}
                src={`${BASE_CDN_IMAGE_URL}/${businessPromotedPaymentMethodData?.button?.btn_content?.image}.svg`}
                alt="card"
              />
            ) : (
              getBtnImage()
            )}
            {btn_content.content}
          </button>
        );
      case 'API_CALL':
        return (
          <button className={className} onClick={() => handleApiCall(config, onClose, id)}>
            {getBtnImage()}
            {btn_content.content}
          </button>
        );
      case 'REDIRECT':
        return (
          <Link
            className={className}
            to={getAbsolutePath(redirect_content?.redirect_url)}
            state={redirect_content?.state}
          >
            {getBtnImage()}
            {btn_content.content}
          </Link>
        );
      case 'CLOSE':
        return (
          <button className={className} onClick={() => handleClose(onClose, id, deleteContent)}>
            {getBtnImage()}
            {btn_content.content}
          </button>
        );
      case 'UPDATE_STATE':
        return (
          <button
            className={className}
            onClick={() => update_state && getStateData && getStateData(update_state)}
          >
            {getBtnImage()}
            {btn_content.content}
          </button>
        );
      default:
        return <div className={className + ' cursor-default'}>{btn_content?.content}</div>;
    }
  };

  const handleClose = (onClose?: any, id?: string, deleteContent?: boolean) => {
    onClose && onClose();
    deleteContent && handleUpdateContent(id);
  };

  const handleApiCall = async (config: Button, onClose?: any, id?: string) => {
    const { api_params } = config;
    if (isEmpty(api_params)) {
      return;
    }
    dispatch(activateLoader());
    try {
      onClose && (await onClose());
      const response = await makeApiCall({ ...api_params, withCredentials: true });
      if (response.status === 200 && response.data && response.data.success) {
        dispatch(disableLoader());
        getNextFlowByAction(config, onClose, id);
      }
      dispatch(disableLoader());
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('advertisement error :', err);
      dispatch(disableLoader());
    }
  };

  const handleUpdateContent = (id?: string) => {
    if (!id) {
      return;
    }
    const contentExists = advertiseContent.find((el) => el.id === id);
    if (contentExists) {
      const updatedContent = [...advertiseContent];
      advertiseContent && updatedContent.splice(advertiseContent.indexOf(contentExists), 1);
      setAdvertiseContent([...updatedContent]);
    }
  };

  const getNextFlowByAction = (config: Button, onClose?: any, id?: string) => {
    const { on_success, popup_content, deleteContent } = config;
    switch (on_success) {
      case 'POPUP': {
        /* 
          if all buttons in popup funtionality is to delete current advertisement
          close icon acts the same 
        */
        const onCloseDelete =
          popup_content?.buttons?.every((button) => button.deleteContent === true) || false;
        handlePopup(popup_content, id, onCloseDelete);
        break;
      }
      case 'CLOSE':
        deleteContent && handleUpdateContent(id);
        onClose && onClose();
        break;
      default:
        break;
    }
  };
  const processSubHeading = (text: string) => {
    const lines = text.split('\n');
    return lines?.map((line, index) => {
      const trimmedLine = line.trim();
      if (trimmedLine === '') {
        return <br key={index} />;
      }
      return (
        <div key={index}>
          {index !== 0 && <Dot />} {trimmedLine}
        </div>
      );
    });
  };

  const handlePopup = (
    popup_content?: Popup,
    id?: string,
    deleteContent?: boolean,
    update_state?: any
  ) => {
    const popUpContent = businessPromotedPaymentMethodData
      ? businessPromotedPaymentMethodData?.pop_up_content
      : popup_content;
    if (isEmpty(popUpContent)) {
      return null;
    }
    //@ts-ignore
    ModalFactory.builder(
      (onClose: any) => (
        <ModalContainer>
          <img
            width={'12px'}
            className="close-icon"
            src={CROSS_ICON}
            alt="close"
            onClick={() => {
              onClose();
              deleteContent && handleUpdateContent(id);
            }}
          />

          {!isEmpty(businessPromotedPaymentMethodData) ? (
            <BannerPopUPWrapper>
              <img src={MOBILE_CIRCLE_ICON} alt={'mobile-circle'} className="image" />
              <div className="heading">{popUpContent?.heading}</div>
              <div className="sub-content">
                <div className="sub-heading">{processSubHeading(popUpContent?.sub_heading)}</div>
              </div>
              <CommonButton
                text={popUpContent?.btn_content}
                onClick={() => {
                  onClose();
                  update_state && getStateData && getStateData(update_state);
                }}
              />
            </BannerPopUPWrapper>
          ) : (
            <>
              <div className="model-content">
                <h2>{popup_content?.heading}</h2>
                <p>{popup_content?.content}</p>
              </div>
              {Array.isArray(popup_content?.buttons) && (
                <div className="btn-wrapper">
                  {popup_content?.buttons.map((button) => {
                    return getElementByAction(button, onClose, id);
                  })}
                </div>
              )}
            </>
          )}
        </ModalContainer>
      ),
      'insta-modal center-modal',
      true,
      { disAbleCloseAnimation: true }
    );
  };

  if (isEmpty(advertiseContent)) {
    return null;
  }

  return (
    <AdvertisingContainer className={className} noMarginRight={noMarginRight}>
      {!isEmpty(businessPromotedPaymentMethodData) ? (
        <>
          <AdvertisingWrapper subContent={false}>
            <div className="bannerContent">
              <div className="bannerHeading" id="advertising_heading">
                {businessPromotedPaymentMethodData?.main_content?.heading}
                {businessPromotedPaymentMethodData?.type && (
                  <RenderElementsWithDelay
                    arrayOfValues={businessPromotedPaymentMethodData?.type}
                    delayTime={3000}
                  />
                )}
              </div>
              {Array.isArray(businessPromotedPaymentMethodData?.main_content?.content) && (
                <div>
                  {businessPromotedPaymentMethodData?.main_content?.content?.map((content: any) => (
                    <div className="bannerSubHeading" id="advertising_subcontent" key={content}>
                      {content}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {getElementByAction(businessPromotedPaymentMethodData?.button, null)}
          </AdvertisingWrapper>
        </>
      ) : (
        <>
          {advertiseContent.length &&
            advertiseContent?.map(({ main_content, button, id }) => (
              <AdvertisingWrapper key={id} id={id} subContent={!isEmpty(main_content.content)}>
                <div className="bannerContent">
                  <div className="bannerHeading" id="advertising_heading">
                    {main_content.heading}
                  </div>
                  {Array.isArray(main_content.content) && (
                    <div className="advertising-subcontent">
                      {main_content.content?.map((content) => (
                        <div className="bannerSubHeading" id="advertising_subcontent" key={content}>
                          {content}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {getElementByAction(button, null, id)}
              </AdvertisingWrapper>
            ))}
        </>
      )}
    </AdvertisingContainer>
  );
};

const mapStateToProps = (state: IStore) => {
  const {
    rootReducer: {
      userStatusReducer: {
        country_code,
        status,
        account_type,
        remitter_id,
        additional_info,
        remitterInfoDataLoaded
      }
    }
  } = state;
  return {
    country_code,
    status,
    account_type,
    remitter_id,
    additional_info,
    remitterInfoDataLoaded
  };
};

export default connect<any, any, any, IStore>(mapStateToProps, (dispatch: any) => ({ dispatch }))(
  Advertising
);
